// components/search/index

import transitionend from "@giantpeach/transition-end";

function Search() {
    this.button = document.querySelector(".search-button");
    this.searchHeader = document.querySelector(".search-header");
    this.input = this.searchHeader.querySelector("input");
    this.close = this.searchHeader.querySelector(".search-header__close");

    this.events = {
        body: this.bodyClick.bind(this),
        transitionend: this.transitionEnd.bind(this)
    };

    this.button.addEventListener("click", this.onClick.bind(this));

    this.searchHeader.addEventListener("click", function (e) {
        e.stopPropagation();
    });
}

Search.prototype.onClick = function () {
    this.searchHeader.classList.toggle("is-visible");
    document.body.classList.toggle("is-search-open");
    document.documentElement.classList.toggle("is-search-open");

    this.searchHeader.addEventListener(transitionend, this.events.transitionend);

};

Search.prototype.transitionEnd = function () {
    document.addEventListener("click", this.events.body);
    this.close.addEventListener("click", this.events.body);
    this.searchHeader.removeEventListener(transitionend, this.events.transitionend);
    this.input.focus();

};

Search.prototype.bodyClick = function () {
    this.searchHeader.classList.remove("is-visible");
    document.body.classList.remove("is-search-open");
    document.documentElement.classList.remove("is-search-open");

    document.removeEventListener("click", this.events.body);
};

export default Search;



// WEBPACK FOOTER //
// ./js/components/search/index.js